import { z } from "zod";

export const sessionRefreshSchema = z.object({
  access_token: z.string(),
  expires_at: z.string(),
  refresh_token: z.string(),
});

export type SessionRefresh = z.infer<typeof sessionRefreshSchema>;
